import {
  AvgAdjustmentByCarrierResponseSchema,
  OMSMetricsRequestSchema,
} from "@redotech/redo-fulfillment-common/metrics";

export const getAvgAdjustmentByCarrier = {
  name: "getAvgAdjustmentByCarrier" as const,
  input: OMSMetricsRequestSchema,
  output: AvgAdjustmentByCarrierResponseSchema,
};
